
<section
    class="loading-overlay"
    [class.loading-overlay--fullscreen]="fullscreen"
    aria-busy="true"
    aria-live="polite"
    role="status"
>
    <div class="loading-overlay__frame" aria-hidden="true">
        <span class="loading-overlay__rule loading-overlay__rule--top"></span>
        <span class="loading-overlay__rule loading-overlay__rule--bottom"></span>
    </div>

    <div class="loading-overlay__content">
        <img
            [src]="logoSrc"
            alt="nibni"
            class="loading-overlay__logo"
            decoding="async"
        />
        <div class="loading-overlay__status">
            <div class="loading-overlay__measure" aria-hidden="true"><span></span></div>
            <p class="loading-overlay__message">{{ message }}</p>
        </div>
    </div>
</section>
    
